import React from 'react';

import { useTranslation } from 'react-i18next';

import type { FormCustomFieldColumn } from 'domains/visitorManagement/flatfile/workbook';

import styles from 'domains/visitorManagement/content-blocks/AddVisitorsBlock.scss';

const reactCSV = require('react-csv');

const { CSVLink } = reactCSV;

const BASE_HEADERS = [
  'Visitor Email',
  'Visitor First Name',
  'Visitor Last Name',
  'Visitor Country Code',
  'Visitor Cell Number',
  'Visitor Company',
];

export function DownloadVisitorInfoSample({
  isPreview = false,
  formCustomFieldColumns = [],
}: {
  isPreview?: boolean;
  formCustomFieldColumns?: FormCustomFieldColumn[];
}): React.ReactElement {
  const { t } = useTranslation();

  const headers = [
    ...BASE_HEADERS,
    ...formCustomFieldColumns.map(c => c.fieldName),
  ];
  const csvData = [headers];

  return isPreview ? (
    <p className={styles.disabledLinkContainer}>
      {t('web.content.feature.visitorManagement.visitorInvite.downloadSample')}
    </p>
  ) : (
    <CSVLink
      data={csvData}
      className={styles.linkContainer}
      filename="VisitorInfo-Template.csv"
    >
      {t('web.content.feature.visitorManagement.visitorInvite.downloadSample')}
    </CSVLink>
  );
}
